import React from 'react';
import Skeleton from '@mui/material/Skeleton';

type Props = {
  widthSkeleton: number;
};

export default function SkeletonLoading(props: Props) {
  return (
    <>
      <Skeleton
        animation="pulse"
        className="table-cell"
        height={16}
        variant="rectangular"
        width={220}
      />
    </>
  );
}
